import { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from 'core/logger';
import { appInsights } from './logger/ApplicationInsightsService';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger?.error('Uncaught error:', error, errorInfo);
    appInsights?.trackException({ error: new Error(`Uncaught error in ActiveWeb UI: ${error}` ), severityLevel: SeverityLevel.Error });
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
